import type { JSX, PropsWithChildren } from 'react';

import { Link } from '@change/ds-core-ui/next';

import { useQRCode } from 'src/app/shared/hooks/qrcode';

type QRCodeDownloadLinkProps = PropsWithChildren<{
	value: string;
	size?: number;
	filename?: string;
	onDownload?: () => Promise<void>;
}>;

/**
 * Renders a link to download a QR code with the given value.
 * The QRCode is not visible, but is used to download a hi-res version of the QRCode
 * @deprecated Use PetitionQRCodeDownloadLink instead.
 */
export function QRCodeDownloadLink({
	children,
	value,
	size = 512,
	filename,
	onDownload,
}: QRCodeDownloadLinkProps): JSX.Element {
	const { data } = useQRCode({ value, size });

	const handleDownload = async () => {
		await onDownload?.();
	};

	return (
		<Link
			href={data ?? '#'}
			download={filename || true}
			onClick={handleDownload}
			bold
			size="small"
			data-qa="qrcode-download-link"
			data-testid="qrcode-download-link"
		>
			{children}
		</Link>
	);
}
